module.exports = __webpack_public_path__ + "img/product_104.2b98c9a.webp";